<template>
<div class="w-85per dp-inblock">
    <div class="title">
        <h2>신청완료</h2>
    </div>
    <div class="agree-box">
        <ckeditor :parentData="editorData" v-model="editorData"></ckeditor>
    </div>
    <div class="line"></div>
    <div class="mt-30 w-100per mg-auto">
        <button @click="prev()" class="admin-btn-default">이전</button>
        <button @click="next()" class="admin-btn-default float-right ml-05">
            <span v-if="isFinishPage">완료하기</span>
            <span v-else>다음</span>
        </button>
        <button @click="save()" class="admin-btn-default float-right ml-05">저장</button>
        <button @click="preview()" class="admin-btn-default float-right">미리보기</button>
    </div>
</div>
</template>

<script>
import Ckeditor from '@/components/utils/ckEditor.vue'
export default {
    data: () => ({
        editorData: '', // 에디터 default 내용,
        isSaved: false, // 저장 여부
        isFinishPage: false // 현재 페이지가 마지막 페이지인지
    }),
    components: {
        Ckeditor
    },
    mounted() {
        if (sessionStorage.getItem('fix')) {
            var idx = sessionStorage.getItem('mainIdx')
            var params = {
                idx: idx
            }
            this.axios.get(this.axios.root + this.axios.port + `/sugang/complete/${idx}`, params)
                .then(res => {
                    console.log('res', res)
                    this.editorData = res.data.complete.complete_contents
                }).catch(err => {
                    console.log(err)
                    alert(err)
                })
        }

        var pathArray = this.$route.fullPath.split('/')
        var length = pathArray.length
        var pageType = pathArray[length - 1]
        var pOrder = JSON.parse(sessionStorage.getItem('pOrder'))
        var finishPage = pOrder[pOrder.length - 1]

        if (pageType === finishPage) {
            this.isFinishPage = true
        }
    },

    methods: {
        // 미리보기
        preview() {
            if (!this.isSaved) {
                alert('미리보기를 하려면 먼저 저장을 해야합니다.')
                return false
            }
            let routeData = this.$router.resolve({
                name: 'preview-complete',
                query: {
                    mainIdx: sessionStorage.getItem('mainIdx')
                }
            });
            window.open(routeData.href, '_blank');
        },
        // 이전 페이지 이동
        prev() {
            var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
            var idx = pOrder.indexOf('complete') - 1
            this.$router.push(`/admin/reg/${pOrder[idx]}`)
            // this.$router.push('/admin/reg/purchase')
        },

        // 다음 페이지 이동
        next() {
            if (this.isSaved) {
                if (this.isFinishPage) {
                    alert('수강신청 등록이 완료되었습니다.')
                    this.$router.push('/admin/list/main')
                } else {
                    var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
                    var idx = pOrder.indexOf('complete') + 1
                    sessionStorage.setItem('step', pOrder[idx])
                    this.$router.push(`/admin/reg/${pOrder[idx]}`)
                }
            } else {
                alert('저장을 먼저 해주세요.')
                return false
            }
        },

        // 현재 페이지 저장
        save() {
            if (this.editorData.trim() === '') {
                alert('내용을 입력해주세요.')
                return false
            }
            var params = {
                completeContents: this.editorData,
                mainIdx: sessionStorage.getItem('mainIdx'),
            }
            this.axios.put(this.axios.root + this.axios.port + '/sugang/complete', params)
                .then(res => {
                    console.log('res', res)
                    if (res.data.err === 0) {
                        this.isSaved = true
                        alert('저장되었습니다.')
                    }
                })
        }
    }
}
</script>
